export {autoOpponent} from './auto-opponent';
export {autoPlayer} from './auto-player';
